import styled, { css } from 'styled-components';

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-top: -10px;
  margin-bottom: 8px;
  position: relative;
  z-index: 1;

  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
    justify-content: start;
  }
`;

export const FixedContainer = styled.div`
  position: relative;
  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.device.mobileL} {
    justify-content: space-between;
  }
`;

export const Sorting = styled.div`
  margin-bottom: 36px;
`;

const gridTempCols = css`
  --padding-inline: 24px;

  display: grid;
  column-gap: 24px;
  padding-inline: var(--padding-inline);

  @media ${({ theme }) => theme.device.mobileL} {
    --padding-inline: 0;
  }
`;

export const LegendAndCard = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['gridTemplateColumns', 'gridTemplateRows'].includes(prop),
})`
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  > * {
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};

    @media ${({ theme }) => theme.device.mobileL} {
      grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows};
    }
  }

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    border-bottom: 1px solid #8b8b8b;
    padding: 24px 16px;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Legend = styled.div`
  ${gridTempCols}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 8px;
    grid-template-columns: 96px;
    align-items: center;
    margin-bottom: 0;

    > *:first-child {
      margin-left: 0;
    }

    > *:last-child {
      margin-right: 0;
    }
  }
`;

export const CardsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasPaginator'].includes(prop),
})`
  padding-bottom: ${({ hasPaginator }) => (hasPaginator ? 48 : 0)}px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const UserCard = styled.div`
  ${gridTempCols}
  align-items: center;
  height: 70px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 8px;
    grid-template-columns: 1fr;
    text-align: end;
    width: 100%;

    //remove card style
    height: auto;
    border-radius: 0;
    background: none;
    box-shadow: none;
  }
`;
